import React, { useState } from "react";

import Input from "components/Input";

import classes from "./styles.module.scss";
import PresetAmount from "../PresetAmount";

const CREDITS_PRESETS = [5, 10];

const SLIDER_MIN = 1;
const SLIDER_MAX = 100;

const clampCredits = (val) => Math.min(SLIDER_MAX, Math.max(SLIDER_MIN, Number(val) || SLIDER_MIN));

const SelectAmount = ({ amountToPurchase, setAmountToPurchase }) => {
    const [customAmount, setCustomAmount] = useState("");

    const fillPercent = ((amountToPurchase - SLIDER_MIN) / (SLIDER_MAX - SLIDER_MIN)) * 100;
    const fillStop = amountToPurchase < SLIDER_MAX * 0.8 ? fillPercent + 0.5 : fillPercent - 1;

    const onCustomAmountChange = (val) => {
        const credits = clampCredits(val);
        setAmountToPurchase(credits);
        setCustomAmount(credits);
    };

    const changeAmount = (val) => {
        setAmountToPurchase(clampCredits(val));
        setCustomAmount("");
    };

    return (
        <div className={classes.selectAmountContainer}>
            <div className={classes.sliderContainer}>
                <div
                    style={{
                        width: "100%",
                        position: "relative",
                    }}
                >
                    <input
                        className={classes.rangeInput}
                        type="range"
                        min={SLIDER_MIN}
                        max={SLIDER_MAX}
                        value={amountToPurchase}
                        onChange={(e) => changeAmount(+e.target.value)}
                        style={{
                            width: "100%",
                            background: `linear-gradient(to right, #003ba0 0%, #003ba0 ${fillStop}%, #f0f9ff ${fillStop}%, #f0f9ff 100%)`,
                        }}
                    />

                    <span
                        className={classes.amountSpan}
                        style={{
                            left: `calc(${fillPercent}% - ${(fillPercent / 100) * 20}px)`,
                            transform: "none",
                        }}
                    >
                        {amountToPurchase}
                    </span>
                </div>
                <div className={classes.sliderInfoContainer}>
                    <span>{SLIDER_MIN}</span>
                    <span>{SLIDER_MAX}</span>
                </div>
            </div>

            <div className={classes.customAndPresetsContainer}>
                {CREDITS_PRESETS.map((credits, index) => (
                    <PresetAmount
                        key={index}
                        amount={credits}
                        isAmountSelected={amountToPurchase === credits}
                        onClick={() => changeAmount(credits)}
                    />
                ))}

                <Input
                    className={classes.customAmountInput}
                    placeholder="Enter Custom Amount"
                    input={{
                        value: customAmount,
                        onChange: (val) => onCustomAmountChange(val),
                    }}
                    hideLabel={true}
                />
            </div>
        </div>
    );
};

export default SelectAmount;
